import React from 'react';
import Box from '@mui/material/Box';

/**
 * Wraps a self-contained, fully-styled HTML document (from `public/`) in a
 * full-viewport iframe so it slots under the SPA navbar without leaking its
 * styles into the React tree.
 *
 * The src files (e.g. `/results.html`, `/comparison.html`) live in
 * `fh-monitor/public/` and are kept in sync with the canonical copies in
 * `2026_Results/` by the corresponding generator scripts:
 *   - `scripts_2026/compute-endurance-scoring.ts`  -> `/results.html`
 *   - `scripts_2026/compare-scoring-vs-official.ts` -> `/comparison.html`
 */
interface Props {
  src: string;
  title: string;
}

const StaticHtmlPage: React.FC<Props> = ({ src, title }) => {
  return (
    <Box
      sx={{
        // Fill the area below the navbar. Navbar minHeight is 48-64px;
        // matching that here keeps both desktop and mobile flush.
        height: { xs: 'calc(100vh - 48px)', sm: 'calc(100vh - 64px)' },
        width: '100%',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
      }}
    >
      <iframe
        src={src}
        title={title}
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          display: 'block',
        }}
      />
    </Box>
  );
};

export default StaticHtmlPage;
